module.exports = __webpack_public_path__ + "aa32fe352538de6ac8bb46eac474f6d7.jpg";